import axios from 'axios';

import { isApiServiceErrorResponse } from '../../../types/guards';

import { ApiResponseError, ApiServiceError } from './useApiService.types';

export const mapErrorToServiceError = <ResponseType extends ApiResponseError = ApiResponseError>(
  error?: unknown
): ApiServiceError<ResponseType> => {
  let serviceError: ApiServiceError<ResponseType>;
  const generalErrorMessage = 'Failed to execute API request';

  if (!error) {
    serviceError = {
      error: new Error(generalErrorMessage),
      message: generalErrorMessage,
    };
  } else if (isApiServiceErrorResponse<ResponseType>(error)) {
    serviceError = error;
  } else if (axios.isAxiosError<ResponseType>(error)) {
    serviceError = {
      error,
      message: error.response?.data?.message || error.response?.statusText || generalErrorMessage,
      statusCode: error.response?.status,
      errorCode: error.response?.data?.code,
    };
  } else if (error instanceof Error) {
    serviceError = {
      error,
      message: error.message,
    };
  } else {
    serviceError = {
      error: new Error(String(error)),
      message: String(error),
    };
  }

  return serviceError;
};
